<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-moon`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M29.882 4.377A20.09 20.09 0 0026 4C14.954 4 6 12.954 6 24s8.954 20 20 20a19.97 19.97 0 0016.115-8.154l1.87-2.539-3.094-.609C33.45 31.234 28 24.678 28 17c0-3.46 1.099-6.749 3.106-9.475l1.87-2.54-3.094-.608zM10 24c0-8.837 7.163-16 16-16h.135A19.93 19.93 0 0024 17c0 8.456 5.286 15.821 12.908 18.707A15.952 15.952 0 0126 40c-8.837 0-16-7.163-16-16z"/></svg>
</template>
<script>

export default {
  name: 'IconMoon',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
